import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ViewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  Department,
  ExpertFields,
  ExpertSearchService,
} from "src/app/services/expert-search.service";
import { DepartmentKeyPopupComponent } from "./department-key-popup/department-key-popup.component";
import { TitleService } from "src/app/services/title.service";

export type DepartmentKey = keyof typeof Department;

@Component({
  selector: "app-expert-directory",
  templateUrl: "./expert-directory.component.html",
  styleUrls: ["./expert-directory.component.scss"],
  standalone: false,
})
export class ExpertDirectoryComponent implements AfterViewInit {
  /** All department keys for the filter list (stable order). */
  readonly departmentKeys: DepartmentKey[] = (Object.keys(
    Department
  ) as DepartmentKey[]).filter(
    (k) => typeof Department[k as keyof typeof Department] === "string"
  );

  departmentFiltersActive: DepartmentKey[] = [];

  displayedColumns: string[] = [
    "name",
    "department",
    "position_title",
    "email",
    "short_keywords",
    "new",
    // "keywords",
    // "searchable_blob",
    // "summary",
  ];
  dataSource: MatTableDataSource<ExpertFields>;

  filterValue: string = "";

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private expertSearch: ExpertSearchService,
    public dialog: MatDialog,
    public _titleService: TitleService,
    private cdr: ChangeDetectorRef
  ) {
    this._titleService.setPageTitle("Expert Directory");
    this.dataSource = new MatTableDataSource([]);

    this.expertSearch
      .search({})
      .subscribe((res: { fields: ExpertFields; id: string }[]) => {
        const experts = res.map((el) => el.fields);
        this.dataSource.data = experts;
        this.dataSource.sort.sort({
          id: "name",
          start: "asc",
          disableClear: false,
        });
      });
  }

  isDepartmentSelected(key: DepartmentKey): boolean {
    return this.departmentFiltersActive.includes(key);
  }

  /** Toggle a department on/off (called from checkbox click). */
  toggleDepartment(key: DepartmentKey): void {
    const idx = this.departmentFiltersActive.indexOf(key);
    if (idx === -1) {
      this.departmentFiltersActive = [...this.departmentFiltersActive, key];
    } else {
      this.departmentFiltersActive = this.departmentFiltersActive.filter(
        (k) => k !== key
      );
    }
    this.applyFilter();
    this.cdr.detectChanges();
  }

  clearDepartmentFilters(): void {
    this.departmentFiltersActive = [];
    this.applyFilter();
  }
  getDepartmentName(abbr: string): string {
    if (!abbr) return "";
    const entry = Object.entries(Department).find(
      ([k]) => k.toLowerCase() === abbr.toLowerCase()
    );
    return entry ? entry[1] : "";
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DepartmentKeyPopupComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event?: Event) {
    if (event) this.filterValue = (event.target as HTMLInputElement).value;

    this.expertSearch
      .search({
        query: this.filterValue,
        departments: this.departmentFiltersActive,
      })
      .subscribe((res: { fields: ExpertFields; id: string }[]) => {
        const experts = res.map((el) => el.fields);
        this.dataSource.data = experts;
      });

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
